export const TriangleAlert = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="currentColor"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.001 0C10.3544 3.16938e-05 10.7015 0.0936102 11.0068 0.271484C11.3121 0.449387 11.565 0.70532 11.7393 1.0127L19.7334 15.0029C19.9086 15.3064 20.0008 15.6506 20.001 16.001C20.0011 16.3515 19.9094 16.6963 19.7344 17C19.5592 17.3037 19.3065 17.5559 19.0029 17.7314C18.6995 17.9069 18.3554 17.9996 18.0049 18H2.01661C1.66449 18.0031 1.31789 17.9132 1.01172 17.7393C0.705408 17.5651 0.449999 17.3131 0.272465 17.0088C0.0949634 16.7045 0.000784208 16.3582 4.03819e-06 16.0059C-0.000707024 15.6537 0.0925009 15.3079 0.268559 15.0029L8.26172 1.0127C8.43602 0.705202 8.68973 0.449438 8.99512 0.271484C9.30045 0.093681 9.64764 0 10.001 0ZM10.0107 13.0029C9.4585 13.0029 9.0108 13.4507 9.01075 14.0029C9.01075 14.5552 9.45846 15.0029 10.0107 15.0029H10.0205C10.5728 15.0029 11.0205 14.5552 11.0205 14.0029C11.0205 13.4507 10.5728 13.0029 10.0205 13.0029H10.0107ZM10.0107 5.00879C9.45857 5.00879 9.01092 5.45665 9.01075 6.00879V10.0059C9.0108 10.5581 9.4585 11.0059 10.0107 11.0059C10.563 11.0059 11.0107 10.5581 11.0107 10.0059V6.00879C11.0106 5.45665 10.5629 5.00879 10.0107 5.00879Z"
      />
    </svg>
  )
}
